const MarkerCluster = () => {
  return (
    <svg className="mr-4" fill="rgb(0, 139, 254)" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240" height="100%" width="100%">
      <circle cx="120" cy="120" opacity=".6" r="70" />
      <circle cx="120" cy="120" opacity=".4" r="95" />
      <circle cx="120" cy="120" opacity=".2" r="120" />
    </svg>
  )
}



export default MarkerCluster
